import {BaseBadge, BaseCard} from "@/components";
import type {Game} from "../games.types";

export interface GameCardProps {
  game: Game;
  onClick?: (game: Game) => void;
}

const GameCard = ({game, onClick}: GameCardProps) => (
  <BaseCard
    variant="surface"
    padding="none"
    interactive={Boolean(onClick)}
    className="overflow-hidden"
  >
    <button
      type="button"
      onClick={onClick ? () => onClick(game) : undefined}
      className="flex w-full flex-col text-left"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-[var(--color-surface-2)]">
        {game.imageUrl ? (
          <img
            src={game.imageUrl}
            alt={game.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-200 ease-out hover:scale-105"
          />
        ) : (
          <div
            className="flex h-full w-full items-center justify-center text-[var(--font-display)]"
            aria-hidden="true"
          >
            🎮
          </div>
        )}
        {game.category && (
          <span className="absolute right-2 top-2">
            <BaseBadge
              variant="brand"
              size="sm"
            >
              {game.category}
            </BaseBadge>
          </span>
        )}
      </div>
      <div className="flex flex-col gap-1 p-3">
        <span className="truncate text-[var(--font-body-lg)] font-bold text-[var(--color-text)]">{game.name}</span>
        {game.provider && (
          <span className="truncate text-[var(--font-body)] text-[var(--color-text-tertiary)]">{game.provider}</span>
        )}
      </div>
    </button>
  </BaseCard>
);

export default GameCard;
